import { AxiosObjPlatformwithOutJWT } from '../configuration/axios-setup';

class otpServices {
    requestOtp(resObj) {
        return AxiosObjPlatformwithOutJWT
          .post(`/api/dpod/coach/request-general-otp`,resObj,{
            headers: {
              'Content-Type': 'application/json'
             }
          })
      }
      verifyOtp(resObj) {
        return AxiosObjPlatformwithOutJWT
          .post(`/api/dpod/coach/verify-general-otp`,resObj,{
            headers: {
              'Content-Type': 'application/json'
             }
          })
      }
      resendOtp(resObj) {
        return AxiosObjPlatformwithOutJWT
          .post(`/api/dpod/coach/resend-general-otp`,resObj,{
            headers: {
              'Content-Type': 'application/json'
             }
          })
      }  
}

const OtpServices = new otpServices();
export default OtpServices;